<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>公司汽车保险登记使用说明:<br>
					<span>1、单号构成规则:201201+BX+4位顺序号。系统生成,添加无效</span><br>
					<span>2、业务说明:一个车牌号一年只允许一条业务单据,每次提交业务单据后自动同步最早保险日期到汽车资料中的保险日期,作废不修改汽车资料中保险日期。</span><br>
					<span>3、查询关键字:汽车编号、车牌。</span><br>
					<span>4、明细:保险公司、车牌号。</span><br>
					<span>5、必须提交才能将保险日期同步到基础资料中。</span><br>
					<span>筛选条件:快到期限30天以内,超过30天不算,保险未录入不算</span>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
		</pre-base>
	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1_new.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''

			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// //事故附件操作老方法 carBX
				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '保险',
					"control": "carInsurance",
					"isTwo": "1",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_car_carInsur',
					"upd_action": 'exp15_car_carInsurance',
					"detail_part": "1",
					"d_sel_action": 'exp_car_carFile',
					"d_upd_action": 'car_carFile',
					"file_action": 'filemore',
					"p1": 'car',
					"p2": 'bx',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "select",
							"class": "long1",
							"sel_action": "data_exp_car",
							"sel_val": {},
							"sel_name": "",
							"sel": "2",
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "3"
						},
						{
							"name": "开始修改时间",
							"val": "",
							"key": "s_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "截止修改时间",
							"val": "",
							"key": "e_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "保险单号",
							"val": "",
							"key": "f_no",
							"type": "text",
							"class": "long1",
							"sel": "6"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "select",
							"class": "long1",
							"sel_action": "data_exp_car",
							"sel_name": "",
							"sel_more": "A_to",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						// {
						// 	"name": "车挂别名",
						// 	"val": "",
						// 	"key": "cp_no",
						// 	"type": "selectnew",
						// 	"class": "long1",
						// 	"sel_action": "_base_car_bm",
						// 	"sel_name": "",
						// 	"sel_more": "A",
						// 	"p": "1",
						// 	"w": "0",
						// 	"r": "0",
						// 	"x": "1"
						// },
						{
							"name": "总费用",
							"val": "",
							"key": "amount",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						// {
						//   "name": "保险项目",
						//   "val": "",
						//   "key": "i_val",
						//   "type": "none",
						//   "class": "long1"
						// },
						// {
						//   "name": "保险期限",
						//   "val": "",
						//   "key": "i_date",
						//   "type": "date",
						//   "class": "long1",
						//   "weight": "1",
						// },
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"p": "1",
							"x": "2"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "车牌号码"
						},
						// {
						//   "name": "保险名称"
						// }, {
						//   "name": "保险项目"
						// }, {
						//   "name": "保险期限"
						// },
						{
							"name": "总费用"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "经办人"
						},
						{
							"name": "明细",
							"class": "long2"
						},
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [{
							"name": "单号",
							"val": '',
							"key": "sheet_no",
							"type": "none",
							"p": "1",
							"r": "1"
						},
						{
							"name": "保险公司",
							"val": '',
							"key": "f_note",
							"type": "text",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "i_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_out_classok_bx",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0"
						},
						{
							"name": "保险期限",
							"val": "",
							"key": "f_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0"
						},
						{
							"name": "费用金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"r": "0"
						},
						{
							"name": "保险单号",
							"val": "",
							"key": "f_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "保险公司"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "费用金额"
						},
						{
							"name": "保险期限"
						},
						{
							"name": "保险单号"
						},
						{
							"name": "有无附件"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "访问地址"
						}
					]

				});

			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				console.log('father type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}

		}
	};
</script>
<style scoped>
	.tab_body>td:nth-child(9) {
		display: none;
	}

	.tab_body>td:last-child {
		display: none;
	}
</style>